import { render } from "./ModalUbicaciones.vue?vue&type=template&id=132a5a21"
import script from "./ModalUbicaciones.vue?vue&type=script&lang=js"
export * from "./ModalUbicaciones.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__